import { Task } from '../../components/organism.task/_task.js';
import { wrapper } from './molecule.content.style.js';
import { jsx } from 'react/jsx-runtime';

function TaskAccordionContent(props) {
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-stack": props.task.type === "stack",
    children: /*#__PURE__*/jsx(Task, {
      task: props.task,
      taskIndex: props.taskIndex
    })
  });
}

export { TaskAccordionContent };
//# sourceMappingURL=molecule.content.js.map
